import { configureStore } from "@reduxjs/toolkit";
import orderReducer from "./orderSlice";
import statusReducer from "./statusSlice";
import subcategoryReducer from "./subcategorySlice";
import languageReducer from "./languageSlice";

const store = configureStore({
  reducer: {
    order: orderReducer,
    statuses: statusReducer,
    subcategory: subcategoryReducer,
    languages: languageReducer,
  },
});

export default store;
